import React from 'react'

const MajorForest = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6 4.11a6.5 6.5 0 01.73 12.96v4.19a.75.75 0 01-1.5 0v-4.19a6.54 6.54 0 01-2.95-1.12 7.16 7.16 0 01-2 .51v4.8a.75.75 0 01-1.5 0v-4.8a7.22 7.22 0 115.91-12.22 7 7 0 011.31-.13zM9.88 14.94c.252-.019.5-.069.74-.15a4.81 4.81 0 001.47-.59 5.73 5.73 0 002.76-4.88A5.56 5.56 0 0013.77 6a5.21 5.21 0 00-1.1-1.19 5.61 5.61 0 00-3.55-1.24 5.71 5.71 0 00-.75 11.37v-4.69L7 9.62a.752.752 0 01.64-1.36l.74.34V7.32a.75.75 0 111.5 0v3.34l.74-.55.16-.11a.76.76 0 011.05.2.75.75 0 01-.17 1.05l-.88.65-.9.66v2.38zm3.51.15a6.31 6.31 0 001.52-1.53l-.08 1.82v.19a4.401 4.401 0 01-1.44-.48zm5.02-1.72l-1.95 2.16-.03.08a5 5 0 00-.86-9.92h-.25a7.18 7.18 0 01.48 6.34.75.75 0 01.64.76v.58l.86-1a.75.75 0 011.11 1z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorForest
